import { Outlet, useLocation } from "react-router-dom";

import { useUserLoading } from "@/hooks/api/useUserLoading";
import { useStore } from "@/hooks/store";
import { APP_ROUTES } from "@/routes/constants";
import { ApiVersion, apiVersion } from "@/utils";

import { HomeSkeleton } from "../Home/HomeSkeleton";
import { Layout } from "../Layout";

const ContentLoader = () => {
  const preload = useStore((store) => store.preload);
  const location = useLocation();
  const { isLoading, error } = useUserLoading();

  if (location.pathname.includes(APP_ROUTES.AIRDROPS) || location.pathname.includes(APP_ROUTES.TOTAL_TRUST_SCORE))
    return (
      <Layout>
        <Outlet />
      </Layout>
    );

  const showSkeleton = isLoading || error || preload;

  return <Layout>{showSkeleton ? <HomeSkeleton isUserLoading={isLoading} /> : <Outlet />}</Layout>;
};

export const App = () => {
  const { nearAccount, evmAccount, solanaAccount, tonAccount } = useStore((store) => ({
    nearAccount: store.user.nearAccount,
    evmAccount: store.user.evmAccount,
    solanaAccount: store.user.solanaAccount,
    tonAccount: store.user.tonAccount,
    stellarAccount: store.user.stellarAccount,
  }));
  console.info("App accounts", { nearAccount, evmAccount, solanaAccount, tonAccount });

  const showSkeleton = apiVersion === ApiVersion.v1 ? !nearAccount || !evmAccount || !tonAccount : !tonAccount;

  return (
    <Layout>{showSkeleton ? <HomeSkeleton isUserLoading={apiVersion == ApiVersion.v1} /> : <ContentLoader />}</Layout>
  );
};
